export const API_CONFIG = {
  BASE_URL: '/api/v1',
  CLIENT_BASE_URL: '/api/openmetadata/v1',
} as const;

export const QUERY_DEFAULTS = {
  Q: '',
  DELETED: false,
  FROM: 0,
  SIZE: {
    AGGREGATION: 0,
    STANDARD: 1000,
    SEARCH_PAGE: 15,
  },
  TRACK_TOTAL_HITS: 10000,
  FETCH_SOURCE: false,
  SORT: {
    FIELD: 'updatedAt',
    ORDER: 'desc' as const,
  },
} as const;

export const INDICES = {
  DATA_ASSET: 'dataAsset',
  DATABASE: 'database_search_index',
  DATABASE_SCHEMA: 'database_schema_search_index',
  TABLE: 'table_search_index',
  TAG: 'tag_search_index',
} as const;
